// PAQUETERÍAS
import { useEffect, useState, useMemo, useRef, useCallback } from "react";
import { CustomDialog } from "react-st-modal";
import NotificationSystem from "react-notification-system";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";


// COMPONENTES
import AlertResponse from "../../../main_components/alerts/alertResponse";
import { refresh_token } from "../../../main_components/tokens/tokenrefresh";
import { BREADCRUMBS } from "../../../main_components/pagination/breadcrumbs";
import RENDER_TOOLBAR_INTERNAL_ACTIONS from "../../../main_components/methods_v2/export";
import RENDER_ROW_ACTION_MENU_ITEMS from "./tools/render_row_action_menuItems";
import OPERATIONS_ASSIGNED_CONCEPTS from "./tools/op_assigned_concepts";
import { update_null_identifiers } from "../../../main_components/methods_v2/auxiliar_funtion";
import MODAL_TABLE from "../../../main_components/modal/modal_Table";

import CREATE from "../../../imgComponents/create.png";

import { expenses_concept_list_get } from "../../../services/expenses/concept";

const ASSIGNED_CONCEPTS_V2 = () => {
  const notificationSystemRef = useRef();
  const [data, setData] = useState([]);
  const [modalT, setModalT] = useState(false);
  const [message, setMessage] = useState("");
  const [modalGeneral, setModalGeneral] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [rowSelection, setRowSelection] = useState({});
  const [totalRows, setTotalRows] = useState("");

  const updateIdentifiers = useMemo(
    () => [
      { concept: "string" },
      { enable: "string" },
      { account: "String" },
      { date_register: "string" },
    ],
    []
  );

  // Función para mostrar alertas
  const showAlert = useCallback((msg, status) => {
    notificationSystemRef.current.addNotification({
      message: <AlertResponse msj={msg} view={status} />,
      level: status ? "success" : "error",
      position: "br",
      autoDismiss: status ? 10 : 60,
    });
  }, []);

  // Función para obtener los datos
  const fetchData = useCallback(async () => {
    console.log("Consultando los conceptos asignados al catálogo...");
    setModalT(true);
    setData([]);
    setIsLoading(true);

    try {
      const rfToken = await refresh_token();
      if (!rfToken) return;

      const response = await expenses_concept_list_get(sessionStorage.getItem("id_catalogo"));
      const updatedData = update_null_identifiers(response?.data, updateIdentifiers);
      setData(updatedData || []);
    } catch (error) {
      console.error("Error al obtener datos:", error);
      setData([]);
    } finally {
      setModalT(false);
      setIsLoading(false);
    }
  }, [updateIdentifiers]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = useMemo(
    () => [
      {
        id: "concept",
        header: "Concepto",
        accessorKey: "concept",
        size: 300,
      },
      {
        id: "enable",
        header: "Estado",
        accessorKey: "enable",
        accessorFn: (row) => (row.enable ? "Habilitado" : "Deshabilitado"),
      },
      {
        id: "account",
        header: "Cuenta",
        accessorKey: "account",
        size: 200,
      },
      {
        id: "date_register",
        header: "Fecha de Registro",
        accessorKey: "date_register",
        size: 300,
      },
    ],
    []
  );


  const handleStateChange = (newState) => {
    const filteredRowsCount = newState.filteredRowModel
    setTotalRows(filteredRowsCount);
  };

  return (
    <>
      <BREADCRUMBS
        niveles={[
          { label: "CATÁLOGO DE CONCEPTOS", path: "/catalog_expense_concept_v2" },
          { label: "CONCEPTOS ASIGNADOS", path: null },
        ]}
        cards_dashboard={true}
        filter_row={totalRows !== "" ? totalRows?.getFilteredRowModel()?.rows?.length : 0}
        visibility_row={data?.length}

        total={data?.length}
      />

      <div className="new_table_v2">
        <NotificationSystem ref={notificationSystemRef} />

        <MODAL_TABLE open={true} message={message} modalGeneral={modalGeneral} modalT={modalT} />

        <MaterialReactTable
          columns={columns}
          data={data}
          enableGrouping
          enableStickyHeader
          enableStickyFooter
          enableRowPinning
          enableColumnFilterModes
          enableRowActions
          enableRowSelection
          getRowId={(row) => row?.id}
          onRowSelectionChange={setRowSelection}
          enableTooltips={false}
          onStateChange={handleStateChange}
          localization={MRT_Localization_ES}
          state={{ rowSelection, isLoading }}
          enableColumnResizing
          enableColumnPinning
          enableColumnOrdering
          initialState={{ showGlobalFilter: true }}
          muiCircularProgressProps={{ color: "secondary", thickness: 5, size: 55 }}
          muiSkeletonProps={{ animation: "pulse", height: 28 }}
          muiTableContainerProps={{
            sx: { maxHeight: "69vh", "@media (max-height: 810px)": { maxHeight: "65vh" } },
          }}
          positionToolbarAlertBanner="bottom"
          paginationDisplayMode="pages"
          rowPinningDisplayMode="sticky"
          muiTableHeadCellProps={{ sx: { flex: "0 0 auto", whiteSpace: "normal !important" } }}
          muiTableBodyCellProps={{ sx: { flex: "0 0 auto", whiteSpace: "normal !important" } }}
          muiPaginationProps={{ color: "primary", shape: "rounded", variant: "outlined" }}
          displayColumnDefOptions={{
            "mrt-row-pin": {
              Header: () => (
                <img
                  title="Asignar Concepto"
                  src={CREATE}
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    await CustomDialog(
                      <OPERATIONS_ASSIGNED_CONCEPTS
                        operation="CREATE"
                        handleSubmit={fetchData}
                        alertas={showAlert}
                        setmodalT={setModalT}
                      />,
                      {
                        className: "custom-modal-3",
                        title: "Asignar Concepto",
                        showCloseIcon: true,
                        isCanClose: false,
                      }
                    );
                  }}
                />
              ),
              enableHiding: true,
            },
            "mrt-row-actions": { enableHiding: true },
          }}
          muiTableBodyRowProps={
            ({ row, table }) => {
              setTotalRows(table);
              const { density } = table.getState();
              return {
                sx: {
                  height: row.getIsPinned()
                    ? `${density === 'compact' ? 30 : density === 'comfortable' ? 35 : 69
                    }px`
                    : undefined,
                },
              };
            }
          }
          renderRowActionMenuItems={({ row, closeMenu }) => (
            <RENDER_ROW_ACTION_MENU_ITEMS
              closeMenu={closeMenu}
              setmodalT={setModalT}
              setmenssage={setMessage}
              setmodalGeneral={setModalGeneral}
              row={row}
              handleSubmit={fetchData}
              refresh_token={refresh_token}
              alertas={showAlert}
            />
          )}
          renderToolbarInternalActions={({ table }) => (
            <RENDER_TOOLBAR_INTERNAL_ACTIONS
              table={table}
              file_name="Consultar Marcas"
              update_identifiers={updateIdentifiers}
            />
          )}
        />
      </div>
    </>
  );
};

export default ASSIGNED_CONCEPTS_V2;
